/**
 * @fileoverview TypeScript interfaces for TareaOrden collection
 * Based on model.json collection pbc_754852763
 */

import { BaseRecord } from '../common/PocketBaseTypes';

/**
 * Main TareaOrden interface representing a production task assignment
 */
export interface TareaOrden extends BaseRecord {
  /** Collection ID for PocketBase */
  collectionId: string;
  /** Collection name for PocketBase */
  collectionName: string;
  
  /** Task completion percentage (0-100) */
  porcentaje?: number;
  
  /** Task status */
  estado?: string;
  
  /** Reference to orden_produccion collection (pbc_3129228651) */
  orden_produccion: string;
  
  /** Reference to plan_centro_costo collection */
  plan: string;
  
  /** Reference to log_plan_centro_costo collection (pbc_1909650630) */
  log_plan: string;
  
  /** Task start date */
  inicio: string;
  
  /** Task completion date (optional) */
  fin?: string;
  
  /** Auto-generated creation timestamp */
  created: string;
  
  /** Auto-generated update timestamp */
  updated: string;
}

/**
 * Data structure for creating a new TareaOrden
 */
export interface CreateTareaOrdenData {
  /** Reference to orden_produccion collection */
  orden_produccion: string;
  
  /** Reference to plan_centro_costo collection */
  plan: string;
  
  /** Reference to log_plan_centro_costo collection */
  log_plan: string;
  
  /** Task start date */
  inicio: string;
  
  /** Task completion date (optional) */
  fin?: string;
}

/**
 * Data structure for updating an existing TareaOrden
 */
export interface UpdateTareaOrdenData {
  /** Reference to orden_produccion collection (optional) */
  orden_produccion?: string;
  
  /** Reference to plan_centro_costo collection (optional) */
  plan?: string;
  
  /** Reference to log_plan_centro_costo collection (optional) */
  log_plan?: string;
  
  /** Task start date (optional) */
  inicio?: string;
  
  /** Task completion date (optional) */
  fin?: string;
}

/**
 * Collection metadata for TareaOrden
 */
export const TAREA_ORDEN_COLLECTION = {
  name: 'tarea_orden',
  id: 'pbc_754852763'
} as const;
